import React, {useState, useEffect} from 'react';
import {Link} from 'react-router-dom';
import {Button} from 'react-bootstrap';
import swal from "sweetalert";
import MainPagetitle from '../../layouts/MainPagetitle';
import bookingmanuallyService from '../../api/services/BookingManually';
import LogoAnimationLoader from '../Loading/LogoAnimationLoader';
const BookingManually = () => {  
    const [bookingmanually, setbookingmanually] = useState([]);
    const [isLoading, setisloading] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);
    const recordsPage = 100;
    const lastIndex = currentPage * recordsPage;
    const firstIndex = lastIndex - recordsPage;
    const records = bookingmanually.slice(firstIndex, lastIndex);
    const npage = Math.ceil(bookingmanually.length / recordsPage)
    const number = [...Array(npage + 1).keys()].slice(1)
    function prePage() {
        if (currentPage !== 1) {
            setCurrentPage(currentPage - 1)
        }
    }
    function changeCPage(id) {
        setCurrentPage(id);
    }
    function nextPage() {
        if (currentPage !== npage) {
            setCurrentPage(currentPage + 1)
        }
    }
    useEffect(() => {
        getbookingmanually();
    }, []);
    const getbookingmanually = async () => {
        try {
          let bookingmanually = await bookingmanuallyService.index().json();
          setbookingmanually(bookingmanually.data);
          setisloading(false);
        } catch (error) {
          console.log(error);
        }
      };
      const deletebookingmanually = async(id) => {
        let responseData = await bookingmanuallyService.destroy(id).json()
          swal({
            title: "Are you sure?",
            text:"Once deleted, you will not be able to recover this data!",
            icon: "warning",
            buttons: true,
            dangerMode: true,
            }).then((willDelete) => {
            if (willDelete) {
                if (responseData.status === 200) {
                    getbookingmanually();
                } 
                swal("Your Camper Video has been deleted successfully!", {
                  icon: "success",
                });
            } 
            }).catch(() => {
                swal("Your Camper Video is safe!");
            });
      }
    return (
        <>
            <MainPagetitle mainTitle="Booking" pageTitle={'Booking'} parentTitle={'Home'} />  
            <div className="container-fluid">
				        <div className="row">
			    	        <div className="col-xl-12">
                        <div className="card">            
                            <div className="card-body p-0">
                                <div className="table-responsive active-projects style-1 ItemsCheckboxSec shorting">   
                                    <div className="tbl-caption d-flex justify-content-between text-wrap align-items-center">
                                        <h4 className="heading mb-0">Booking Manually</h4>                                        
                                        <div>
                                            <Link to={`/admin/addbooking/`} className="btn btn-primary btn-sm ms-1">+ Add Booking</Link> {" "}
                                        </div>
                                    </div>          
                                    <div id="employee-tbl_wrapper" className="dataTables_wrapper no-footer">
                                        <table id="empoloyees-tblwrapper" className="table ItemsCheckboxSec dataTable no-footer mb-0">
                                            <thead>
                                                <tr>   
                                                    <th>Index</th>
                                                    <th>First & last name</th>
                                                    <th>Email</th>
                                                    <th>Phone number</th>
                                                    <th>City</th>
                                                    <th className="d-flex">Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {records.map((item, index)=>(
                                                    <tr key={index}>   
                                                        <td>
                                                            <div className="products">
                                                                <h6>{index+1}</h6>
                                                            </div>
                                                        </td>
                                                        <td>
                                                        <div className="">
                                                                <h6>{item.name}</h6>
                                                            </div>
                                                        </td>
                                                        <td>
                                                        <div className="">
                                                                <h6>{item.email}</h6>
                                                            </div>
                                                        </td>
                                                        <td>
                                                        <div className="">
                                                                <h6>{item.phone}</h6>
                                                            </div>
                                                        </td>
                                                        <td>
                                                        <div className="">
                                                                <h6>{item.city}</h6>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div className="d-flex">
                                                                <Link
                                                                to={`/admin/edit_booking/${item.id}`}
                                                                className="btn btn-primary shadow btn-xs sharp me-1"
                                                                >
                                                                <i className="fas fa-pencil-alt"></i>
                                                                </Link>
                                                                <Button className="btn btn-danger shadow btn-xs sharp" onClick={() => {deletebookingmanually(item.id)}} 
                                                                >
                                                                <i className="fa fa-trash"></i>
                                                                </Button>
                                                            </div>
                                                        </td>
                                                       
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                        <div className="d-sm-flex text-center justify-content-between align-items-center">
                                            <div className='dataTables_info'>
                                                Showing {lastIndex - recordsPage + 1} to{" "}
                                                {bookingmanually.length < lastIndex ? bookingmanually.length : lastIndex}
                                                {" "}of {bookingmanually.length} entries
                                            </div>
                                            <div
                                                className="dataTables_paginate paging_simple_numbers justify-content-center"
                                                id="example2_paginate"
                                            >
                                                <Link
                                                    className="paginate_button previous disabled"
                                                    to="#"
                                                    onClick={prePage}
                                                >
                                                    <i className="fa-solid fa-angle-left" />
                                                </Link>
                                                <span>
                                                    {number.map((n, i) => (
                                                        <Link className={`paginate_button ${currentPage === n ? 'current' : ''} `} key={i}
                                                            onClick={() => changeCPage(n)}
                                                        >
                                                            {n}

                                                        </Link>
                                                    ))}
                                                </span>
                                                <Link
                                                    className="paginate_button next"
                                                    to="#"
                                                    onClick={nextPage}
                                                >
                                                    <i className="fa-solid fa-angle-right" />
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {isLoading && <LogoAnimationLoader />}
        </>
    );
};

export default BookingManually;